import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../services/alerts.service';
import { ConnectionService } from '../../services/connection.service';
import { finalize } from 'rxjs/operators';
import { BlockUIHandlerService } from '../../services/block-uihandler.service';
import { ALERTS } from '../../common/enums';
import { AppConstants } from 'src/app/models';
import { IConnection } from '../../models/i-connection';
import { FormBuilder, FormGroup, NgbModal, Validators } from 'src/app/common/angular.index';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-connections',
  templateUrl: './connections.component.html',
  styleUrls: ['./connections.component.css']
})
export class ConnectionsComponent implements OnInit {

  connections: IConnection[];

  connectionForm: FormGroup;

  modalRef: NgbModalRef;

  constructor(
    private alertService: AlertService,
    private connectionService: ConnectionService,
    private blockUI: BlockUIHandlerService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.ResetConnectionForm();
    this.LoadData();
  }

  ResetConnectionForm(): void {
    this.connectionForm = this.formBuilder.group({
      Id: -1,
      Name: ['', Validators.required],
      Server: ['', Validators.required],
      DST: [''],
      DBUser: ['', Validators.required],
      DBPass: [''],
      UpdatePassword: [false],
      Trusted: [true, Validators.required],
      ODBCType: ['', Validators.required],
      DBEngine: [''],
      ServerType: ['', Validators.required],
      Status: [true, Validators.required],
    });
  }

  LoadData(): void{
    this.LoadConnections();
  }

  LoadConnections(): void{
    try{
      this.blockUI.Start(1, 'Cargando conexiones...');
      this.connectionService.GetConnections()
      .pipe(finalize(() => this.blockUI.taskFinished()))
      .subscribe(next => {
        try{
          if(next.Result){
            this.connections = next.Data;
          } else {
            this.alertService.ShowBigCenteredAlert(AppConstants.GetError(next.ErrorInfo), ALERTS.error);
          }
        } catch(exception){
          console.log(exception);
        }
      }, error => {
        this.alertService.ShowBigCenteredAlert(AppConstants.GetError(error), ALERTS.error);
      });
    } catch(exception){
      console.log(exception);
    }
  }

  RaiseModal(content: any): void {
    this.modalRef = this.modalService.open(content, {
      centered: true,
      size: 'lg',
      backdrop: 'static'
    });
  }

  NewConnection(content: any): void {
    this.ResetConnectionForm();
    this.RaiseModal(content);
  }

  EditConnection(content: any, connection: IConnection){
    this.ResetConnectionForm();
    this.connectionForm.patchValue({
      ...connection
    })
    this.RaiseModal(content);
  }

  StoreConnection(): void {
    try{
      let connection = this.connectionForm.value as IConnection;

      this.blockUI.Start(1, 'Guardando conexión...');
      this.connectionService.StoreConnection(connection)
      .pipe(finalize(() => this.blockUI.taskFinished()))
      .subscribe(next => {
        try{
          if(next.Result){
            this.modalRef.close();
            this.LoadData();
            this.alertService.ShowBigCenteredAlert('Gurdada exitosamente!', ALERTS.success);
          } else {
            this.alertService.ShowBigCenteredAlert(AppConstants.GetError(next.ErrorInfo), ALERTS.error);
          }
        } catch(exception){
          console.log(exception);
        }
      }, error => {
        this.alertService.ShowBigCenteredAlert(AppConstants.GetError(error), ALERTS.error);
      });
    } catch(exception){
      console.log(exception);
    }
  }
}
